import { CURRENCY } from "./../types/formConstants";
import { useFormik } from "formik";
import { useContext, useEffect, useState } from "react";
import { FormContext } from "../FormContextProvider";
import InsuranceService from "../Service/service";
import { VehicleClass, VehicleFormInfo } from "../types/form";
import { useVehicles } from "./vehicleService";
import { scrollToTop } from "../scrollToTop";

export interface VehicleItem {
  id: string;
  name: string;
}
const useVechicleForm = (nextStep: () => void) => {
  const service = new InsuranceService();
  const {
    setVehicleData,
    setCustomerId,
    customerData,
    vehicleData,
    viewedPlans,
    customerId,
    setAmis,
    setRate,
    amis,
  } = useContext(FormContext);
  const {
    vehicleList,
    setVehicleClass,
    setUseType,
    getVersions,
    handleClose,
    getModels,
    getBrands,
    setText,
    setShow,
    loading,
    show,
    text,
  } = useVehicles();
  const [saving, setSaving] = useState(false);
  const [vehicleMake, setVehicleMake] = useState<VehicleItem[]>([]);
  const [vehicleModel, setVehicleModel] = useState<VehicleItem[]>([]);
  const [vehicleVersion, setVehicleVersion] = useState<VehicleItem[]>([]);
  const [vehicleYear, setVehicleYear] = useState<string[]>([]);
  const [loadingPrice, setLoadingPrice] = useState(false);
  const [editing, setEditing] = useState(false);
  const [amount, setAmount] = useState({
    min: 0,
    max: 0,
  });

  const initialValues = vehicleData;

  const handleSubmit = (values: VehicleFormInfo) => {
    if (formik.isValid) {
      setVehicleData(values);
    }
  };

  const formik = useFormik({
    initialValues,
    onSubmit: handleSubmit,
    validateOnBlur: true,
    enableReinitialize: true,
  });

  const handleInsuranceAmountChange = (e: any) => {
    formik.setFieldValue("insuranceAmount", e.target.value);
  };

  const handleVehicleChange = (event: any, field: string) => {
    formik.setFieldValue(`${field}`, event.target.value);
    if (!loading && viewedPlans) {
      setEditing(true);
    }
  };

  const updateVehicleSelection = (list: VehicleItem[], field: string) => {
    if (list.length > 0) {
      formik.setFieldValue(`${field}`, list[0].id);
    }
  };

  const isBike = () => {
    return formik.values.class === VehicleClass.BIKE;
  };

  const next = () => {
    setVehicleData(formik.values);
    const payload = {
      vehicle: formik.values,
      customer: customerData,
    };

    setSaving(true);
    if (viewedPlans) {
      service
        .udpateClientData(customerId, payload)
        .then((res) => {
          if (res.data && res.data.statusCode === 200) {
            setEditing(false);
            nextStep();
          }
        })
        .finally(() => setSaving(false));
    } else {
      service
        .sendClientData(payload)
        .then((res) => {
          if (res.data && res.data.body && res.data.body.id) {
            setCustomerId(res.data.body.id);
            setEditing(false);
            nextStep();
          } else {
            setText(
              "Hubo un problema al cargar los datos por favor intente de nuevo"
            );
            setShow(true);
          }
        })
        .finally(() => {
          setSaving(false);
        });
    }
  };

  const isElectric = (version: string) => {
    return version.includes("ELECTRICO");
  };

  useEffect(() => {
    scrollToTop();
    const years = [];
    for (let i = new Date().getFullYear() + 1; i >= 1990; i--) {
      years.push(i.toString());
    }
    setVehicleYear(years);
    viewedPlans && formik.setFieldValue("class", vehicleData.class);
    viewedPlans && formik.setFieldValue("year", vehicleData.year);
    viewedPlans && formik.setFieldValue("type", vehicleData.type);
    viewedPlans && formik.setFieldValue("currency", vehicleData.currency);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (formik.values.class) {
      setVehicleClass(formik.values.class);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values.class]);

  useEffect(() => {
    if (formik.values.type) {
      setUseType(formik.values.type);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values.type]);

  useEffect(() => {
    if (!loading && vehicleList) {
      const makes = getBrands();
      setVehicleMake(makes);
      (!viewedPlans || (viewedPlans && editing)) &&
        updateVehicleSelection(makes, "make");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vehicleList, loading]);

  useEffect(() => {
    if (!loading && vehicleMake.length > 0 && viewedPlans && !editing) {
      formik.setFieldValue("make", vehicleData.make);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vehicleMake]);

  useEffect(() => {
    if (!loading) {
      const models = getModels(formik.values.make);
      setVehicleModel(models);
      (!viewedPlans || (viewedPlans && editing)) &&
        updateVehicleSelection(models, "model");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values.make, vehicleMake, loading]);

  useEffect(() => {
    if (!loading && vehicleModel.length > 0 && viewedPlans && !editing) {
      formik.setFieldValue("model", vehicleData.model);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vehicleModel]);

  useEffect(() => {
    if (!loading) {
      const versions = getVersions(formik.values.make, formik.values.model);
      setVehicleVersion(versions);
      (!viewedPlans || (viewedPlans && editing)) &&
        updateVehicleSelection(versions, "version");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values.model, vehicleModel, loading]);

  useEffect(() => {
    if (formik.values.version && isElectric(formik.values.version)) {
      formik.setFieldValue("currency", CURRENCY.usd);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values.version]);

  useEffect(() => {
    if (!loading && vehicleVersion.length > 0 && viewedPlans && !editing) {
      formik.setFieldValue("version", vehicleData.version);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vehicleVersion]);

  useEffect(() => {
    if (formik.values.version) {
      const version: any = vehicleVersion.find(
        (version) => version.id === formik.values.version
      );
      version && setAmis(version.amis);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values.version, vehicleVersion, loading]);

  useEffect(() => {
    if (amis && formik.values.year && formik.values.currency) {
      setLoadingPrice(true);
      service
        .getPrice(
          formik.values.year,
          amis,
          formik.values.currency === CURRENCY.usd ? "USD" : "CRC"
        )
        .then((res: any) => {
          if (res.data) {
            let range = {
              min: res.data.min,
              max: res.data.max,
            };
            let insuranceAmount = Math.round(res.data.value);
            if (formik.values.class === VehicleClass.BIKE) {
              range = {
                min: formik.values.currency === CURRENCY.usd ? 1200 : 600000,
                max: formik.values.currency === CURRENCY.usd ? 40000 : 20000000,
              };
              insuranceAmount = Math.round((range.min + range.max) / 2);
              setAmount(range);
            } else {
              const roundFactor =
                formik.values.currency === CURRENCY.usd ? 1000 : 500000;
              const round = (roundFunction: any, value: number) =>
                roundFunction(value / roundFactor) * roundFactor;
              const min = round(Math.ceil, range.min);
              const max = round(Math.floor, range.max);
              insuranceAmount = round(Math.round, (min + max) / 2);
              setAmount({
                min: min,
                max: max,
              });
            }

            setRate(res.data.rate);
            if (viewedPlans && !editing) {
              formik.setFieldValue(
                "insuranceAmount",
                vehicleData.insuranceAmount
              );
            } else {
              formik.setFieldValue("insuranceAmount", insuranceAmount);
            }
          }
        })
        .finally(() => {
          setLoadingPrice(false);
        });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values.year, amis, formik.values.currency]);

  return {
    handleInsuranceAmountChange,
    handleVehicleChange,
    vehicleVersion,
    loadingPrice,
    vehicleModel,
    handleClose,
    vehicleMake,
    vehicleYear,
    isElectric,
    loading,
    isBike,
    formik,
    saving,
    amount,
    next,
    text,
    show,
  };
};

export default useVechicleForm;
